import React from 'react';
import { Provider } from 'react-redux';
import store from '../store';
import Router from '../routes';
import { I18nextProvider } from 'react-i18next';
import i18n from '../i18n/i18n';

const EstimotoApp = () => {
  return (
    <I18nextProvider i18n={i18n}>
      <Provider store={store}>
        <Router />
      </Provider>
    </I18nextProvider>
  );
};

export default EstimotoApp;
